import React, { ReactNode } from 'react'
import { SvgWarningTriangle } from '@chilipiper/icons'
import { Icon } from '../icon'
import { Text } from '../../new/core-components/text'
import { SystemProps } from '../../new/theme'
import { BrandingFooter } from '../branding-footer'
import { Flex, Box } from '../../new/core-components/box'

interface Props {
  children?: ReactNode
  message: string
  showFooter?: boolean
}

export const WarningPage = ({ message, children, showFooter, ...props }: Props & SystemProps) => {
  return (
    <Flex h='100%' w='100%' justifyContent='center' alignItems='center' flexDirection='column'>
      <Flex
        h='100%'
        w='100%'
        px={[6, 0]}
        justifyContent='center'
        alignItems='center'
        flexDirection='column'
        bg='bg/page'
        {...props}
      >
        <Icon mb={6} h={8} w={8} icon={SvgWarningTriangle} color='icon/indicator' />
        <Text
          textAlign='center'
          fontWeight={500}
          lineHeight='150%'
          maxWidth={24}
          color='text/heading-major'
          data-test-id='WarningPage-text'
        >
          {message}
        </Text>
        {children}
      </Flex>
      {showFooter && (
        <Box w='100%' bg='bg/minor' position='fixed' bottom={0}>
          <BrandingFooter anchorLink='https://www.chilipiper.com/page/powered-by-chili-piper?utm_medium=product&utm_source=vir&utm_campaign=bookinglink' />
        </Box>
      )}
    </Flex>
  )
}
